import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue';
import type { CButtonVariant } from '.';


export default /*#__PURE__*/_defineComponent({
  __name: 'CButton',
  props: {
    text: null,
    icon: null,
    size: { default: 'md' },
    variant: null,
    disabled: { type: Boolean },
    type: { default: 'button' }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'click', e: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { text?: string, icon?: string | string[], size: string, variant?: CButtonVariant, disabled?: boolean, type: 'button' | 'submit' };





const slots = useSlots();

const btnVariant = computed(() => (props.variant?.length ? props.variant : 'empty'));

return { __sfc: true,props, emit, slots, btnVariant }
}

})